import * as Component from 'src/feature/bite/component'
import {Field, Form, Formik} from 'formik'
import * as Yup from 'yup'
import {useIntl} from 'react-intl'
import {useCreateVIPTier} from '../context/useMutation'
import {useGetProgramDetail} from '../context/useQuery'
import {useVIP} from '../hook'
import {useNavigate} from 'react-router-dom'
import {NumericFormat} from 'react-number-format'

function AddVipTier() {
  useGetProgramDetail()

  const navigate = useNavigate()
  const intl = useIntl()
  const {isLoading, mutateAsync} = useCreateVIPTier()
  const {program} = useVIP()

  const validSchema = Yup.object({
    name: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(50, intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: 50})),
    value: Yup.number()
      .min(1, intl.formatMessage({id: 'GLOBAL.ERROR.MIN_LIMIT_INPUT'}, {length: 1}))
      .max(999999.99, intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: 999999.99}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    icon: Yup.string(),
    status: Yup.number(),
  })

  const onSubmit = async (values, {setSubmitting, resetForm}) => {
    if (isLoading) return
    if (values.icon === '') values.icon = 'icon.png'
    await mutateAsync({values})
    setSubmitting(false)
  }

  return (
    <>
      <div className='d-flex gap-5 align-items-center'>
        <button
          className='btn btn-primary btn-sm'
          onClick={() => {
            navigate('/vip')
          }}
        >
          <i className='fa fa-arrow-left'></i>
        </button>
        <Component.Breadcrumb currentPage={intl.formatMessage({id: 'VIP.ADD.TIER'})} />
      </div>
      <Formik
        initialValues={{
          name: '',
          value: '',
          icon: '',
          status: 1,
        }}
        validationSchema={validSchema}
        onSubmit={onSubmit}
      >
        {({values, errors, touched, setFieldValue, setFieldTouched}) => (
          <Form>
            <div className='row  mt-10'>
              <div className='col-md-8'>
                <div className='card'>
                  <div className='card-header border-0'>
                    <div className='card-title d-flex flex-column'>
                      <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                        {intl.formatMessage({id: 'VIP.ADD.TIER'})}
                      </div>
                    </div>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='form-group mb-5 w-50'>
                          <label className='form-label fw-bold'>
                            {intl.formatMessage({id: 'VIP.TIER.NAME'})}
                          </label>
                          <p className=' fs-6 text-muted'>
                            {intl.formatMessage({id: 'VIP.TIER.NAME.DESC'})}
                          </p>
                          <Field
                            type='text'
                            name='name'
                            className='form-control'
                            placeholder='e.g. Champions'
                            maxLength={51}
                          />
                          {errors.name && touched.name && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors?.name}</div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='col-md-12'>
                        <div className='form-group mb-5 w-50'>
                          <label className='form-label fw-bold'>
                            {intl.formatMessage({id: 'VIP.TIER.REQUIREMENT'})}
                          </label>
                          <p className=' fs-6 text-muted'>
                            {program?.entryMethodType === 1
                              ? intl.formatMessage({id: 'VIP.TIER.REQUIREMENT.POINT'})
                              : program?.entryMethodType === 2
                              ? intl.formatMessage({id: 'VIP.TIER.REQUIREMENT.SPENT'})
                              : intl.formatMessage({id: 'VIP.TIER.REQUIREMENT.ORDER'})}
                          </p>

                          <NumericFormat
                            name='value'
                            className='form-control'
                            placeholder='e.g. 250'
                            maxLength={10}
                            allowLeadingZeros={false}
                            allowNegative={false}
                            decimalScale={0}
                            onValueChange={(values) => {
                              setFieldValue('value', values.floatValue)
                            }}
                            onBlur={() => setFieldTouched('value', true)}
                          />
                          {errors.value && touched.value && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.value}</div>
                            </div>
                          )}
                          <span className=' fs-8'>
                            {/* This tier must have a goal of{' '}
                            {<span className='fw-bold'>{values.value}</span>} points for customers
                            to use as the base tier. */}
                            {/* {intl.formatMessage(
                              {id: 'VIP.TIER.INFO'},
                              {point: values.value || 250}
                            )} */}

                            {/* {program?.entryMethodType === 1
                              ? intl.formatMessage(
                                  {id: 'VIP.TIER.INFO.POINT'},
                                  {point: values.value}
                                )
                              : program?.entryMethodType === 2
                              ? intl.formatMessage(
                                  {id: 'VIP.TIER.INFO.SPENT'},
                                  {point: values.value}
                                )
                              : intl.formatMessage(
                                  {id: 'VIP.TIER.INFO.ORDER'},
                                  {point: values.value}
                                )} */}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-4'>
                <div className='card'>
                  <div className='card-header border-0'>
                    <div className='card-title d-flex flex-column'>
                      <div className='d-flex align-items-center position-relative fs-4 fw-bold'>
                        {intl.formatMessage({id: 'VIP.TIER.REWARD.SUMMARY'})}
                      </div>
                    </div>
                  </div>
                  <div className='card-body mt-0 pt-0'>
                    <li className='list-group-item d-flex align-items-center'>
                      <i className='bi bi-dot fs-2 text-primary'></i>
                      <span className='fs-6'>
                        {values.name || intl.formatMessage({id: 'VIP.TIER.NAME'})}
                      </span>
                    </li>
                    <li className='list-group-item d-flex align-items-center'>
                      <i className='bi bi-dot fs-2 text-primary'></i>
                      <span className='fs-6 text-muted'>
                        {/* {intl.formatMessage(
                          {id: 'VIP.TIER.REWARD.SUMMARY.DESC.1'},
                          {point: values.value || 250}
                        )} */}

                        {program?.entryMethodType === 1
                          ? intl.formatMessage(
                              {id: 'VIP.TIER.REWARD.SUMMARY.DESC.POINT'},
                              {point: values.value || 0}
                            )
                          : program?.entryMethodType === 2
                          ? intl.formatMessage(
                              {id: 'VIP.TIER.REWARD.SUMMARY.DESC.SPENT'},
                              {point: values.value || 0}
                            )
                          : intl.formatMessage(
                              {id: 'VIP.TIER.REWARD.SUMMARY.DESC.ORDER'},
                              {point: values.value || 0}
                            )}
                      </span>
                    </li>
                    {/* <li className='list-group-item d-flex align-items-center'>
                      <i className='bi bi-dot fs-2 text-primary'></i>
                      <span className='fs-6'>
                        {intl.formatMessage({ id: 'VIP.TIER.REWARD.SUMMARY.DESC.2' })}
                      </span>
                    </li> */}
                  </div>
                </div>

                <button
                  type='submit'
                  className='btn btn-primary mt-10 w-100'
                  disabled={program?.processing || false}
                >
                  {isLoading ? (
                    <span className='indicator-label'>
                      {intl.formatMessage({id: 'PLEASE_WAIT'})}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    <span className='indicator-label'>
                      {intl.formatMessage({id: 'GLOBAL.BUTTON.CREATE'})}
                    </span>
                  )}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default AddVipTier
